<template>
	<div class="position-relative">
		<div v-if="isFactor">
			<select2 :id="id" 
				:name="name"
				:disabled="loading || disabled"
				v-model="form.id">
				<option v-for="valor in valores" :value="valor.codigo">{{valor.descripcion}}</option>
			</select2>
		</div>
		<div v-else class="w-100">
			<input 
				:id="id+'hidde'" 
				:name="name" 
				class="d-none"
				:disabled="loading || disabled" 
				@input="handlerInputKey()" 
				v-model="form.id"
				autocomplete="off">
			<input 
				:id="id" 
				:class="classChildVal + ' w-100'"
				:disabled="loading || disabled" 
				@input="handlerInput()" 
				@blur="blurHandler()"
				@focus="showOptions=true"
				ref="item" 
				v-model="form.name"
				autocomplete="off">
			<div class="position-absolute autocomplete-container-list" v-show="showOptions">
				<div class="list-group">
					<div v-if="filteredValores.length>0" v-for="valor in filteredValores" v-on:click.prevent="setValue(valor)" :class="{'list-group-item cursor-pointer':true,'active':valor.codigo==form.id}">
						{{valor.descripcion}}
					</div>
					<div v-else class="list-group-item disabled" aria-disabled="true">
						No hay registros
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['value', 'disabled', 'id', 'name', 'title', 'column', 'tipoPrestamo', 'classChild'],

		data(){
			return {
				valores: [],
				loading: false,
				search: '',
				form: {
					id: '',
					name: ''
				},
				enabledInput: false,
				showOptions: false,
				isFactor: false
			}
		},

		mounted(){
			this.form.id = this.value
			this.getValores()
		},

		methods: {
			blurHandler(){
				if (!$(this.$el).find('.autocomplete-container-list').is(':hover')) {
					this.showOptions = false
				}
			},

			handlerInput(){
				var value = this.$refs.item.value
				this.search = value.toLowerCase() || ''
				this.form.id = value
			},

			handlerInputKey(){
				this.$emit('input', this.form.id)
			},

			setValue(val){
				this.form.id = val.codigo
				this.form.name = val.descripcion

				this.search = ''
				this.showOptions = false
			},

			getDefaultValues(){
				if (!this.value) {return}
				var data = this.valores.filter(x => x.codigo.includes(this.value))
				if (data.length>0) {
					this.form.name = data[0].descripcion
				}else{
					this.form.name = this.value
				}

				//this.form.id = this.value
			},

			getValores(){
				if (!this.columnValue) {
					return
				}
				var vm = this
				this.loading = true
				var url = `api/catalogos/factores/valores/dynamic`

				axios.post(url, {
					column: this.columnValue,
					tipoPrestamo: this.tipoPrestamoValue,
				})
				.then(response => {
					this.enabledInput = false
					this.valores = response.data.datos
					if (response.data.factores == 1) {
						this.isFactor = true
					}else{
						this.isFactor = false
					}
					
					if (response.data.factores == 2) {
						this.enabledInput = true
					}
				}).catch(error => {
					if (this.columnValue == 'OPORTUNIDAD_PRESTAMO.CODIGO_TIPO_PRESTAMO') {
						console.log(error.response);
					}
					this.enabledInput = true
					this.isFactor = false
				}).then(()=>{
					this.loading = false
					this.$nextTick(() => {
				    	vm.getDefaultValues()
				    })
				})
			},
		},
		computed: {
			columnValue(){
				return this.column
			},

			tipoPrestamoValue(){
				return this.tipoPrestamo
			},

			filteredValores(){
				if (this.search) {
					return this.valores.filter(x => x.descripcion.includes(this.search))
				}
				return this.valores
			},
			classChildVal(){
				return (this.classChild || '') + ' form-control form-control-sm'
			}
		},

		watch: {
			value(val, oldValue){
				this.form.id = val
				if (this.enabledInput) {
					this.form.name = val
				}

				if (!oldValue) {
					this.getDefaultValues()
				}
			},

			columnValue(){
				this.getValores()
				this.form.id = ''
				this.form.name = ''
				this.$refs.item.focus()
			},

			form: {
				handler(val, oldValue){
					/*if (this.column == 'OPORTUNIDAD_PRESTAMO.MONTO_SOLICITADO') {
						console.log('watch.form')
						console.log(val)
						console.log(oldValue)
						console.log('------')
					}*/
					this.$emit('input', val.id)
			    },
			    deep: true
			}
		}
	}
</script>